<template>
	<div class="layout-menu-container">
		<span style="font-size: 14px;font-weight: 500;color: #0051cf;padding-left: 2px;">{{ moduleMenuTitle }}</span>
		<AppSubmenu :items="model" class="layout-menu" :root="true" @menuitem-click="onMenuItemClick" :key="menuKey"/>
	</div>
</template>

<script>
import AppSubmenu from './Submenu';

export default {
	props: {
		model: Array
	},
	data() {
		return {
			menuKey: 0
		}
	},
	computed: {
		moduleStore() {
			const moduleStore = this.$route.query.module || sessionStorage.getItem('moduleStore') || localStorage.getItem('moduleStore') || this.$store.getters.moduleStore || null;
			return moduleStore;
		},
		moduleMenuTitle() {
			var title = '';
			if(this.moduleStore == 'system') {
				title = 'Module Hệ thống';
			} else if(this.moduleStore == 'contractors_management') {
				title = 'Quản lý nhà thầu';
			}else if(this.moduleStore == 'risk_management') {
				title = 'Quản lý rủi ro';
			}else if(this.moduleStore == 'for_super_admin') {
				title = 'Dành cho Super Admin';
			}else {
				title = 'Chức năng hệ thống';
			}
			// console.log('[Menu.vue] computed moduleMenuTitle:', title);
			return title;
		}
	},
	methods: {
		onMenuItemClick(event) {
			this.$emit('menuitem-click', event);
		}
	},
	components: {
		'AppSubmenu': AppSubmenu
	},
	mounted() {
	},
	watch: {
		$route() {
			setTimeout(() => {
				if (this.$router.currentRoute.path == "/admin/403") {
					this.menuKey++;
				}
			}, 100)
		},
	},
}
</script>

<style scoped>

</style>
